import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegistrationPageComponent } from './registration/pages/registration-page/registration-page.component';
import { PageNotFoundComponent } from './shared/pages/page-not-found/page-not-found.component';
import {ConfirmEmailPageComponent} from './registration/pages/confirm-email-page/confirm-email-page.component';
import { LoginPageComponent } from './login/pages/login-page/login-page.component';
import {TroubleSigningInPageComponent} from './trouble-signing-in/pages/trouble-signing-in-page/trouble-signing-in-page.component';
import {ResetPasswordPageComponent} from './reset-password/pages/reset-password-page/reset-password-page.component';


const routes: Routes = [
  { path: 'memberLogin', component: LoginPageComponent },
  { path: 'registration', component: RegistrationPageComponent },
  { path: 'confirm-email', component: ConfirmEmailPageComponent },
  { path: 'trouble-signing-in', component: TroubleSigningInPageComponent },
  { path: 'reset-password', component: ResetPasswordPageComponent },
  { path: '',   redirectTo: '/memberLogin', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
